import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = API_BASE_URL;

const handle = (error, fallback) => {
    if (error.response?.data) throw error.response.data;
    throw error.message || fallback;
};

// 1. Queue of MRRs pending this user's verification (role/CC scoped server-side)
export const getTransferRecieptOthersQueue = async (roleId, uid) => {
    try {
        const response = await axios.get(`${base}/Purchase/GetTransferRecieptOthersDetails`, { params: { Roleid: roleId, UID: uid } });
        return response.data;
    } catch (error) { return handle(error, 'Failed to fetch MRR verification queue'); }
};

// 2. Item-level grid for one MRR — column set differs client-side by Type ("From Vendor" vs "From Other Store")
export const getTransferRecieptOtherItems = async (mrrno, type) => {
    try {
        const response = await axios.get(`${base}/Purchase/GetTransferRecieptDataGridOthers`, { params: { Mrrno: mrrno, Type: type } });
        return response.data;
    } catch (error) { return handle(error, 'Failed to fetch MRR item details'); }
};

// 3. Verify/Approve/Reject — "From Other Store" branch (Lost/Damaged qty only, no item-level CSVs)
export const verifyTransferRecieptOther = async (payload) => {
    try {
        const response = await axios.put(`${base}/Purchase/VerifyTransferRecieptother`, payload);
        return response.data;
    } catch (error) { return handle(error, 'Failed to submit verification'); }
};

// 4. Verify/Approve/Reject — "From Vendor" branch (per-item CSV qty/price lists)
export const verifyItemTransferVendorOthers = async (payload) => {
    try {
        const response = await axios.put(`${base}/Purchase/verifyitemtransferVendorothers`, payload);
        return response.data;
    } catch (error) { return handle(error, 'Failed to submit verification'); }
};
